/* src/locations/reducers.js */

import { combineReducers } from 'redux';
import _ from 'lodash';

import {
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAIL,
} from '../../config/constants/actionTypes';

import locationInputReducer from './cards/AddLocationCard/reducers';

export const INITIAL_STATE = {
  byID: {},
  browse: {
    IDs: [],
    start: 0,
    end: 10,
    totalPages: 1,
    loading: false,
    error: '',
    count: '0',
  },
};

const setBrowse = (state, { type, payload }) => {
  switch (type) {
    case FETCH_LOCATIONS:
      return { ...state, loading: true, error: '' };
    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        IDs: _.map(_.get(payload, 'locationsAdmin.locations'), '_id'),
        start: 0, // payload.start,
        end: 10, // payload.end,
        count: '10000', // payload.count,
        loading: false,
        error: '',
      };
    case FETCH_LOCATIONS_FAIL:
      return { ...state, loading: false, error: payload };
    default:
      return state;
  }
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LOCATIONS:
      return { ...state, browse: setBrowse(state.browse, action) };
    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        byID: _.keyBy(_.get(action, 'payload.locationsAdmin.locations'), '_id'),
        browse: setBrowse(state.browse, action),
      };
    case FETCH_LOCATIONS_FAIL:
      return { ...state, browse: setBrowse(state.browse, action) };
    default:
      return state;
  }
};

export default combineReducers({
  input: locationInputReducer,
  main: reducer,
});



// WEBPACK FOOTER //
// ./src/modules/locations/reducers.js